import React from "react";
import TextField from "@material-ui/core/TextField";
import { CircularProgress, InputAdornment } from "@material-ui/core";

const LoadingAutocomplete = ({ loading = true, label = "" }) => {
  if (!loading) {
    return null;
  }

  return (
    <TextField
      variant="outlined"
      fullWidth
      label={label}
      disabled
      value="Loading..."
      size="small"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <CircularProgress size={20} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default LoadingAutocomplete;
